import React from "react";
import toast from "react-hot-toast";

// Compatibility shim to replace react-toast-notifications' useToasts
// Supports signature: addToast(ReactNode, { autoDismiss }) and returns id
export const useToasts = () => {
  const addToast = (element, options = {}) => {
    let id;

    // If element is a valid React element, ensure onSecondaryClick dismisses the toast
    const node = React.isValidElement(element)
      ? (() => {
          const originalOnSecondary = element.props?.onSecondaryClick;
          const wrapped = () => {
            try {
              if (typeof originalOnSecondary === "function") originalOnSecondary();
            } finally {
              toast.dismiss(id);
            }
          };
          return React.cloneElement(element, {
            onSecondaryClick: wrapped,
          });
        })()
      : element;

    const duration = options?.autoDismiss === false ? Infinity : options?.autoDismissTimeout || 5000;

    id = toast.custom(node, {
      position: "top-right",
      duration,
    });

    return id;
  };

  const removeToast = (id) => toast.dismiss(id);

  return { addToast, removeToast };
};

export default useToasts;

